import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "./DocumentSetting.css";
import AddCategory from "./AddCategory";
import { useParams } from "react-router-dom";
import {
  DeleteDocumentsSubCategory,
  DeleteDocumentsCategory,
  getDocumentsCategory,
  updateDocumentsCategory,
  updateCategoryOrder,
  createDocumentsSubCategory,
  updateDocumentsSubCategory,
  updateSubCategoryOrder,
} from "../../api/axios";
import DeleteIcon from "../../Assets/delete.svg";
import editIcon from "../../Assets/edit.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CmsCircularProgress from "../../Components/Common/CircularProgress";
import Nodata from "../NoData/NoData";
import EditCategoryModal from "./EditCategoryModal";
import DeleteSubCategoryModal from "./DeleteSubCategory";
import DeleteCategoryModal from "./DeleteCategoryModal";
import { Form, Button, InputGroup, Row, Col } from "react-bootstrap";
import SubcategoryAddForm from "./SubcategoryAddForm";
import AddCategoryModal from "./AddCategoryModal";

const PageWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 12px 16px;
  margin-bottom: 10px;
  position: relative;
`;

const CategoryRow = styled.div`
  display: flex;
   flex-wrap: wrap;
  align-items: center;
  padding: 5px 0;
    @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const CategoryControls = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const CategoryName = styled.div`
  font-size: 16px;
  font-weight: 500;
  flex: 1;
  margin-left: 6px;
`;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 0.2s;
  ${CardContainer}:hover & {
    opacity: 1;
  }
`;

const SubcategoryContainer = styled.div`
  margin-left: 28px;
  margin-top: 4px;
  border-left: 1px solid #eee;
  padding-left: 12px;
`;

const SubcategoryRow = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  margin-bottom: 2px;
`;

const SubcategoryLabel = styled.div`
  flex: 1;
  margin-left: 6px;
`;

const DragHandle = styled.div`
  cursor: grab;
  color: #aaa;
  font-size: 16px;
  margin-right: 6px;
`;

const ExpandButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  padding: 0 5px;
  display: inline-block;
  cursor: pointer;
`;

const CategoryCount = styled.div`
  color: #888;
  font-size: 14px;
  margin-left: auto;
  margin-right: 6px;
`;

const AddButton = styled.button`
  background-color: #fff;
  color: #47b0e2;
  border: 1px solid #47b0e2;
  border-radius: 24px;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin: 15px auto;
  transition: all 0.2s;
  &:hover {
    background-color: #47b0e2;
    color: white;
  }
`;

const AddNewButton = styled.button`
  background-color: #f0f8ff;
  color: #47b0e2;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 2px;
  margin-bottom: 4px;
`;

const SubcategoryInput = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 8px;
  width: 100%;
  
  input {
    flex: 1;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    margin-right: 10px;
    
    &:focus {
      outline: none;
      border-color: #47b0e2;
    }
  }
`;

const ActionButton = styled.button`
  background-color: ${props => props.primary ? '#7cc0e7' : '#fff'};
  color: ${props => props.primary ? '#fff' : '#333'};
  border: 1px solid ${props => props.primary ? '#7cc0e7' : '#e0e0e0'};
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
  min-width: 100px;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${props => props.primary ? '#5eaad6' : '#f5f5f5'};
  }
`;

const DocumentSetting = () => {
  const { partnerId } = useParams();

  const [showDeleteMsg, setShowDeleteMsg] = useState(false);
  const [showCategoryDeleteMsg, setShowCategoryDeleteMsg] = useState(false);
  const [subCategoryDeleteID, setSubCategoryDeleteID] = useState("");
  const [categoryDeleteID, setCategoryDeleteID] = useState("");
  const [subCategoryEditData, setSubCategoryEditData] = useState(null);
  const [categoryEditData, setCategoryEditData] = useState(null);
  const [submittingEditData, setSubmittingEditData] = useState(false);
  const [addCategoryData, setAddCategoryData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [allOptions, setAllOptions] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  
  // Track which categories are currently adding/editing subcategories
  const [addingSubcategory, setAddingSubcategory] = useState({});
  const [editingSubcategory, setEditingSubcategory] = useState({});
  const [newSubcategoryName, setNewSubcategoryName] = useState('');
  const [isSubmittingSubcategory, setIsSubmittingSubcategory] = useState(false);
  const [isDeletingCategory, setIsDeletingCategory] = useState(false);
  const [isDeletingSubCategory, setIsDeletingSubCategory] = useState(false);
  const [categoryDeleteError, setCategoryDeleteError] = useState("");
  const [subCategoryDeleteError, setSubCategoryDeleteError] = useState("");
  const [categoryEditError, setCategoryEditError] = useState("");
  
  const handleAddSubcategoryClick = (categoryId) => {
    setAddingSubcategory({
      ...addingSubcategory,
      [categoryId]: true
    });
    setNewSubcategoryName('');
  };
  
  const handleCancelAddSubcategory = (categoryId, editData = null) => {
    if (editData) {
      // Cancel editing
      setEditingSubcategory({
        ...editingSubcategory,
        [categoryId]: null
      });
    } else {
      // Cancel adding
      setAddingSubcategory({
        ...addingSubcategory,
        [categoryId]: false
      });
    }
  };
  const handleSaveSubcategory = async (categoryId, name, editData = null) => {
    if (!name.trim()) return;
    
    setIsSubmittingSubcategory(true);
    
    try {
      if (editData) {
        // Edit existing subcategory
        const response = await updateDocumentsSubCategory({
          id: editData.id,
          category_id: categoryId,
          name: name,
          partner_id: partnerId
        });

        if (response.status === 200) {
          // Update local state
          const updatedOptions = [...allOptions];
          const categoryIndex = updatedOptions.findIndex(item => item.value === categoryId);
          
          if (categoryIndex !== -1 && updatedOptions[categoryIndex].sub_category) {
            const subIndex = updatedOptions[categoryIndex].sub_category.findIndex(
              sub => sub.id === editData.id
            );
            
            if (subIndex !== -1) {
              updatedOptions[categoryIndex].sub_category[subIndex] = {
                ...updatedOptions[categoryIndex].sub_category[subIndex],
                name: name
              };
              
              setAllOptions(updatedOptions);
            }
          }
          
          // Clear editing state
          setEditingSubcategory({
            ...editingSubcategory,
            [categoryId]: null
          });
        }

      } else {
        // Add new subcategory
        const response = await createDocumentsSubCategory({
          category_id: categoryId,
          name: name,
          partner_id: partnerId
        });

        if (response.status === 200) {
          // Refresh data to get new subcategory
          await fetchDropdownData();
          
          // Clear adding state
          setAddingSubcategory({
            ...addingSubcategory,
            [categoryId]: false
          });
        }
      }

    } catch (error) {
      throw error;
      
    } finally {
      setIsSubmittingSubcategory(false);
    }
  };
  // const handleSaveSubcategory = async (categoryId, name, editData = null) => {
  //   if (!name.trim()) return;
    
  //   setIsSubmittingSubcategory(true);
    
  //   try {
  //     if (editData) {
  //       // Handle editing subcategory
  //       // Here you would make an API call to update the subcategory
  //       // For example:
  //       // await updateSubcategory({
  //       //   id: editData.id,
  //       //   category_id: categoryId,
  //       //   name: name,
  //       //   partner_id: partnerId
  //       // });
        
  //       // For now, update local state to simulate API call
  //       const updatedOptions = [...allOptions];
  //       const categoryIndex = updatedOptions.findIndex(item => item.value === categoryId);
        
  //       if (categoryIndex !== -1 && updatedOptions[categoryIndex].sub_category) {
  //         const subIndex = updatedOptions[categoryIndex].sub_category.findIndex(
  //           sub => sub.id === editData.id
  //         );
          
  //         if (subIndex !== -1) {
  //           updatedOptions[categoryIndex].sub_category[subIndex] = {
  //             ...updatedOptions[categoryIndex].sub_category[subIndex],
  //             name: name
  //           };
            
  //           setAllOptions(updatedOptions);
  //         }
  //       }
        
  //       // Clear editing state
  //       setEditingSubcategory({
  //         ...editingSubcategory,
  //         [categoryId]: null
  //       });
  //     } else {
  //       // Handle adding new subcategory (existing functionality)
  //       const updatedOptions = [...allOptions];
  //       const categoryIndex = updatedOptions.findIndex(item => item.value === categoryId);
        
  //       if (categoryIndex !== -1) {
  //         if (!updatedOptions[categoryIndex].sub_category) {
  //           updatedOptions[categoryIndex].sub_category = [];
  //         }
          
  //         updatedOptions[categoryIndex].sub_category.push({
  //           id: `temp-${Date.now()}`, // This would come from the API in real implementation
  //           name: name
  //         });
          
  //         setAllOptions(updatedOptions);
  //       }
        
  //       // Close the form
  //       setAddingSubcategory({
  //         ...addingSubcategory,
  //         [categoryId]: false
  //       });
  //     }
      
  //     setNewSubcategoryName(name);
  //   } catch (error) {
  //     console.error("Error saving subcategory:", error);
  //   } finally {
  //     setIsSubmittingSubcategory(false);
  //   }
  // };

  const handleAddCategory = () => {
    setShowAddCategoryModal(true);
  };

  useEffect(() => {
    if (Number(partnerId)) {
      fetchDropdownData();
    }
  }, [partnerId]);

  const fetchDropdownData = async () => {
    setIsLoading(true);
    try {
      const response = await getDocumentsCategory(partnerId);
      
      const fetchedOptions = response.data.data.map((item) => ({
        value: item.id,
        label: item.category,
        sub_category: item.sub_category,
      }));
      
      setAllOptions(fetchedOptions);
      
      // Initialize expanded state for new categories
      const newExpandedState = {};
      fetchedOptions.forEach(item => {
        if (expandedCategories[item.value] === undefined) {
          newExpandedState[item.value] = true; // Default to expanded
        } else {
          newExpandedState[item.value] = expandedCategories[item.value];
        }
      });
      setExpandedCategories(newExpandedState);
      
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateCategory = async () => { 
    setSubmittingEditData(true);
    setCategoryEditError("");
    try {
      const dataToSend = {
        id: categoryEditData?.value,
        name: categoryEditData?.label,
        partner_id: partnerId,
      };
      await updateDocumentsCategory(dataToSend);
      fetchDropdownData();
      setCategoryEditData(null);
      setAddCategoryData(false);
    } catch (error) {
      setCategoryEditError(error?.response?.data?.message || "Failed to update category. Please try again.");
      console.error("Error updating category:", error);
    } finally {
      setSubmittingEditData(false);
    }
  };

  const handleBack = () => {
    setSubCategoryEditData(false);
    setShowForm(false);
    setShowAddCategoryModal(false);
    // fetchDropdownData();
  };

  const handleCategoryDelete = (id) => {
    setCategoryDeleteID(id);
    setCategoryDeleteError("");
    setShowCategoryDeleteMsg(true);
  };
  
  const confirmCategoryDelete = async () => {
    setIsDeletingCategory(true);
    setCategoryDeleteError("");
    try {
      await DeleteDocumentsCategory(categoryDeleteID);
      setShowCategoryDeleteMsg(false);
      await fetchDropdownData();
    } catch (err) {
      setCategoryDeleteError(err?.response?.data?.message || "Failed to delete category. Please try again.");
      console.log(err);
    } finally {
      setIsDeletingCategory(false);
    }
  };

  const handleDelete = (id) => {
    setSubCategoryDeleteID(id);
    setSubCategoryDeleteError("");
    setShowDeleteMsg(true);
  };
  
  const confirmDelete = async () => {
    setIsDeletingSubCategory(true);
    setSubCategoryDeleteError("");
    try {
      await DeleteDocumentsSubCategory(subCategoryDeleteID);
      setShowDeleteMsg(false);
      await fetchDropdownData();
    } catch (err) {
      setSubCategoryDeleteError(err?.response?.data?.message || "Failed to delete subcategory. Please try again.");
      console.log(err);
    } finally {
      setIsDeletingSubCategory(false);
    }
  };

  const handleCategoryEditClick = (itemData) => {
    setCategoryEditData(itemData);
    setAddCategoryData(true);
  };
  
  const handleEditClick = (sub, item) => {
    // Set up the editing state for this category
    setEditingSubcategory({
      ...editingSubcategory,
      [item.value]: {
        id: sub.id,
        category: item.value,
        sub_category: sub.name
      }
    });
    
    // Make sure the category is expanded
    if (!expandedCategories[item.value]) {
      toggleExpand(item.value);
    }
  };

  // Toggle expand/collapse for a category
  const toggleExpand = (categoryId) => {
    setExpandedCategories({
      ...expandedCategories,
      [categoryId]: !expandedCategories[categoryId]
    });
  };

  // Handle drag and drop
  const onDragEnd = (result) => {
    const { destination, source, type } = result;
    
    // Dropped outside the list
    if (!destination) {
      return;
    }
    
    // If dropped in the same position
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    
    // If we're dragging categories (parent items)
    if (type === 'CATEGORY') {
      const reorderedOptions = Array.from(allOptions);
      const [movedItem] = reorderedOptions.splice(source.index, 1);
      reorderedOptions.splice(destination.index, 0, movedItem);
      
      setAllOptions(reorderedOptions);
      
      // Make an API call to update the order in the backend
      try {
        updateCategoryOrder(reorderedOptions.map((item, index) => ({ 
          id: item.value, 
          order: index + 1 
        })));
      } catch (error) {
        console.error("Error updating category order:", error);
        fetchDropdownData();
      }
    } 
    // If we're dragging subcategories
    else if (type === 'SUBCATEGORY') {
      // Extract the category ID from the droppable ID
      const categoryId = source.droppableId.split('-')[1];
      
      // Find the category
      const categoryIndex = allOptions.findIndex(item => item.value.toString() === categoryId);
      
      if (categoryIndex !== -1) {
        // Create a new copy of all options
        const newAllOptions = [...allOptions];
        
        // Get the subcategories for this category
        const subCategories = [...newAllOptions[categoryIndex].sub_category];
        
        // Reorder subcategories
        const [movedSubcategory] = subCategories.splice(source.index, 1);
        subCategories.splice(destination.index, 0, movedSubcategory);
        
        // Update the subcategories in the copied array
        newAllOptions[categoryIndex] = {
          ...newAllOptions[categoryIndex],
          sub_category: subCategories
        };
        
        // Update state
        setAllOptions(newAllOptions);
        
        // Here you would typically make an API call to update the subcategory order
        // For example:
        updateSubCategoryOrder(subCategories.map((sub, index) => ({ 
          id: sub.id, 
          order: index + 1 
        })));
      }
    }
  };

  return (
    <>
      <PageWrapper>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h2 className="document-title">Document Settings</h2>
          </div>
          <div>
            <button
              type="button"
              className="btn add-category-btn mb-0"
              onClick={handleAddCategory}
            >
              <span className="me-sm-2" style={{ fontSize: '18px' }}>+</span> 
              <span className="d-none d-sm-block mr-sm-2">Add category</span>
            </button>
          </div>
        </div>
        
        <>
          {isLoading ? (
            <div className="text-center py-5">
              <CmsCircularProgress />
            </div>
          ) : allOptions.length === 0 ? (
            <Nodata />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="categories" type="CATEGORY">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {allOptions?.map((item, categoryIndex) => (
                      <Draggable 
                        key={`category-${item.value}`} 
                        draggableId={`category-${item.value}`} 
                        index={categoryIndex}
                      >
                        {(provided, snapshot) => (
                          <CardContainer
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            className={snapshot.isDragging ? "dragging" : ""}
                          >
                            <CategoryRow>
                              <CategoryControls>
                                <DragHandle {...provided.dragHandleProps}>⋮⋮⋮</DragHandle>
                                <ExpandButton onClick={() => toggleExpand(item.value)}>
                                  {expandedCategories[item.value] ? '-' : '+'}
                                </ExpandButton>
                                <CategoryName>{item.label}</CategoryName>
                                <CategoryCount>
                                  {item.sub_category?.length || 0} subcategories
                                </CategoryCount>
                                <ActionButtons>
                                  <button
                                    onClick={() => handleCategoryEditClick(item)}
                                    className="edit-button me-2"
                                  >
                                    <img src={editIcon} alt="Edit" />
                                  </button>
                                  <button
                                    onClick={() => handleCategoryDelete(item.value)}
                                    className="delete-button"
                                  >
                                    <img src={DeleteIcon} alt="Delete" />
                                  </button>
                                </ActionButtons>
                              </CategoryControls>
                            </CategoryRow>
                            
                            {expandedCategories[item.value] && (
                              <Droppable
                                droppableId={`subcategory-${item.value}`}
                                type="SUBCATEGORY"
                              >
                                {(provided) => (
                                  <SubcategoryContainer
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    {item.sub_category?.length > 0 && 
                                      item.sub_category.map((sub, subIndex) => (
                                        <Draggable
                                          key={`subcategory-${sub.id}`}
                                          draggableId={`subcategory-${sub.id}`}
                                          index={subIndex}
                                        >
                                          {(provided, snapshot) => (
                                            <>
                                              {editingSubcategory[item.value]?.id === sub.id ? (
                                                <SubcategoryAddForm
                                                  categoryId={item.value}
                                                  editData={editingSubcategory[item.value]}
                                                  onSave={handleSaveSubcategory}
                                                  onCancel={handleCancelAddSubcategory}
                                                />
                                              ) : (
                                                <SubcategoryRow
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  className={snapshot.isDragging ? "dragging" : ""}
                                                >
                                                  <DragHandle {...provided.dragHandleProps}>⋮⋮⋮</DragHandle>
                                                  <SubcategoryLabel>{sub.name}</SubcategoryLabel>
                                                  <ActionButtons>
                                                    <button
                                                      onClick={() => handleEditClick(sub, item)}
                                                      className="edit-button me-2"
                                                    >
                                                      <img src={editIcon} alt="Edit" />
                                                    </button>
                                                    <button
                                                      onClick={() => handleDelete(sub.id)}
                                                      className="delete-button"
                                                    >
                                                      <img src={DeleteIcon} alt="Delete" />
                                                    </button>
                                                  </ActionButtons>
                                                </SubcategoryRow>
                                              )}
                                            </>
                                          )}
                                        </Draggable>
                                      ))
                                    }
                                    {provided.placeholder}
                                    
                                    {addingSubcategory[item.value] ? (
                                      <SubcategoryAddForm
                                        categoryId={item.value}
                                        onSave={handleSaveSubcategory}
                                        onCancel={handleCancelAddSubcategory}
                                      />
                                    ) : (
                                      <AddNewButton onClick={() => handleAddSubcategoryClick(item.value)}>
                                        <span style={{ marginRight: '5px' }}>+</span> Add sub category
                                      </AddNewButton>
                                    )}
                                    
                                  </SubcategoryContainer>
                                )}
                              </Droppable>
                            )}
                          </CardContainer>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
          
          {/* <button
            className="add-category-btn mx-auto d-block mt-4"
            onClick={handleAddCategory}
            style={{ border: '1px solid #47b0e2', borderRadius: '24px', padding: '8px 16px' }}
          >
            <span style={{ marginRight: '8px' }}>+</span> Add New Category
          </button> */}
        </>
      </PageWrapper>
      
      {showDeleteMsg && (
        <DeleteSubCategoryModal
          confirmDelete={confirmDelete}
          setShowDeleteMsg={setShowDeleteMsg}
          isLoading={isDeletingSubCategory}
          error={subCategoryDeleteError}
        />
      )}
      {showCategoryDeleteMsg && (
        <DeleteCategoryModal
          confirmDelete={confirmCategoryDelete}
          setShowDeleteMsg={setShowCategoryDeleteMsg}
          isLoading={isDeletingCategory}
          error={categoryDeleteError}
        />
      )}
      {addCategoryData && (
        <EditCategoryModal
          submittingEditData={submittingEditData}
          setAddCategoryData={setAddCategoryData}
          updateCategory={updateCategory}
          setCategoryEditData={setCategoryEditData}
          categoryEditData={categoryEditData}
          error={categoryEditError}
          setError={setCategoryEditError}
        />
      )}
      {showAddCategoryModal && (
        <AddCategoryModal
          handleBack={handleBack}
          allOptions={allOptions}
          setAllOptions={setAllOptions}
          partnerId={partnerId}
          editData={subCategoryEditData}
          setShowModal={setShowAddCategoryModal}
        />
      )}
    </>
  );
};

export default DocumentSetting;
